<template>
    <div>
        <e-dialog
                dialogTitle="确认支付"
                :centerDialogVisible="visible"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'600px'">
            <div>
                <div>确认已向平台支付服务费，并上传支付凭证</div>
                <el-upload
                        :headers="headers"
                        class="upload-demo"
                        :action="fileUploadUrl"
                        :on-success="handleSuccess"
                        :before-upload="handleBeforeUpload"
                        :show-file-list="false"
                        :auto-upload="true"
                        accept=".jpg,.png">
                    <div class="upload">
                        <span class="margin-left-4"><span style="margin-right: 10px">+</span>选择图片</span>
                    </div>
                </el-upload>
                <div v-if="fileList.name" class="img-box">
                    <div class="img-name">{{fileList.name}} </div>
                    <div class="close" @click="deleteFile"></div>
                </div>
                <div>支持jpg、png格式，不超过10mb</div>
            </div>
        </e-dialog>
    </div>
    
</template>

<script>
    import fileUploadApi from "../../../api/product/index.js";
    import {epecToken} from "../../../utils/globalData";
    import eDialog from "../../../components/common/e-dialog";
    export default {
        name: "uploadDialog",
        components:{eDialog},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
        },
        data(){
            return{
                headers: epecToken,
                fileUploadUrl:fileUploadApi.fileUploadForStatementAccount,
                fileList:{name:'',attachmentUrl:''},
            }
        },
        methods:{
            deleteFile(){
                this.$message.success('删除成功。');
                this.fileList = {name:'',attachmentUrl:''};
            },
            resetPopupData(){
                this.$emit('closeDialog');
            },
            submitPopupData(){
                if(!this.fileList.name){
                    return  this.$message.warning('请选择图片。');
                }
                this.$emit('submitUploadData',this.fileList);
            },
            //附件上传成功处理
            handleSuccess(res){
                if(this.fileList.name){
                    this.$message.warning('只能上传1个附件');
                    return
                }
                if(res.success){
                    this.fileList.name = res.data.fileName ;
                    this.fileList.attachmentUrl = res.data.fileUrl ;
                }
            },
            handleBeforeUpload(file){
                let size = file.size/1024/1024;
                if(size > 10){
                    return this.$message.warning('图片不能超过10M');
                }
                let fileNameLastIndex = file.name.lastIndexOf('.');
                let fileNameLast = file.name.substring(fileNameLastIndex);
                let fileNameLastArr = ['.jpg','.png'];
                if(!fileNameLastArr.includes(fileNameLast)){
                   return  this.$message.warning('只支持jpg、png格式图片。');
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .upload{
        width: 108px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        border: 1px dashed #999;
        margin: 20px 0;
        .margin-left-4{
            margin-left: 10px;
        }
        &:hover{
            border: 1px dotted #2587FF;
            color: #2587FF;
        }
    }

    .img-box{
        position: relative;
         .img-name{
            color: #2d8cf0;
            margin-bottom: 20px;
            cursor:pointer ;
            padding: 4px;
            width: 300px;
            &:hover{
                background-color: #8c939d;
            }
        }

        .close{
            width: 12px;
            height: 12px;
            cursor: pointer;
            position: absolute;
            left: 274px;
            top: 4px;
            background: url("../../../../../assets/img/success.png") no-repeat center center;
            background-size: 12px;
         }
        &:hover .close{
            background: url("../../../../../assets/img/close.png") no-repeat center center;
            background-size: 10px;
        }
    }




</style>